// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__gQHZS","tab":"Tabs_tab__1LVOr","container":"Tabs_container__1ym_t","active":"Tabs_active__3tvom"};